module.exports = __webpack_public_path__ + "478de505b656cf200a462de91b87841e.svg";